import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { WEEKDAYS, WEEKDAY_COLORS, getVisitsForDateAndSite, VisitCell } from "./reportHelpers";

export const SiteReport = ({ weekDates, weekTitle, activeSites, visits, studies, onVisitClick }) => (
  <Card className="border-0 shadow-lg mb-8" data-testid="site-report">
    <CardHeader><CardTitle className="text-xl font-bold text-gray-900 mb-4">{weekTitle}</CardTitle></CardHeader>
    <CardContent>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gradient-to-r from-green-500 to-emerald-500 text-white">
              <th className="border border-gray-300 p-3 text-left font-medium w-32">Site</th>
              {weekDates.map((date, i) => (
                <th key={`site-${date.toISOString()}`} className="border border-gray-300 p-3 text-center font-medium min-w-48">
                  <div className={`font-bold ${WEEKDAY_COLORS[i]}`}>{WEEKDAYS[i]}</div>
                  <div className="text-sm font-normal">{date.getDate()}-{date.toLocaleDateString('en-US', { month: 'short' })}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {activeSites.map((site, siteIndex) => (
              <tr key={site.id} className={siteIndex % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                <td className="border border-gray-300 p-3 font-medium text-gray-900">
                  <div className="truncate" title={site.name}>{site.name.length > 20 ? site.name.substring(0, 20) + '...' : site.name}</div>
                  {site.coordinator && <div className="text-xs text-gray-500 mt-1">PI: {site.coordinator}</div>}
                </td>
                {weekDates.map((date) => {
                  const siteVisits = getVisitsForDateAndSite(date, site.id, visits);
                  return (
                    <td key={`site-${site.id}-${date.toISOString()}`} className="border border-gray-300 p-2 align-top">
                      <div className="space-y-1">
                        {siteVisits.map(v => (
                          <VisitCell
                            key={v.id || `${v.patient_name}-${v.visit_type}`}
                            visit={v}
                            studies={studies}
                            onClick={() => onVisitClick(v)}
                          />
                        ))}
                        {siteVisits.length === 0 && <div className="text-gray-400 text-xs text-center py-2">-</div>}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CardContent>
  </Card>
);
